<template>
    <v-layout>
        <v-flex class="scroll-y pb-64">
            <text-field :label="`${$t('azioni.cerca')}...`" v-model="search" solo-inverted flat
                prepend-inner-icon="search" class="input--dense mb-2" />

            <template v-if="showedAgricoltore == true">
                <v-flex xs1 class="ml-2 py-2" style="cursor: pointer;" @click="showedAgricoltore = false">
                    <v-icon size="30">mdi-arrow-left</v-icon>
                </v-flex>
                <v-flex xs11>
                    <icon-label icon="business" color="accent">{{ $t('agricoltori.label.dati_azienda')
                    }}</icon-label>
                </v-flex>

                <text-field :label="$t('label.ragione_sociale')" v-model="azienda_mostrata.ragione_sociale" required
                    disabled />

                <v-layout xs12>
                    <v-flex xs12 md6>
                        <text-field :label="$t('label.partita_iva')" v-model="azienda_mostrata.partita_iva" show-details
                            :v-rules="[$utils.rules.partitaIVA]" disabled />
                    </v-flex>

                    <v-flex xs12 md6>
                        <text-field :label="$t('label.cuaa')" v-model="azienda_mostrata.cuaa" mask="NNNNNNNNNNNNNNNN"
                            show-details :v-rules="[$utils.rules.cuaa]" :disabled="showedAgricoltore" required />
                    </v-flex>
                </v-layout>

                <div style="width: 98%" class="mt-4">
                    <icon-label icon="location_on" class="mt-4" color="accent">{{ $t('label.indirizzo') }}</icon-label>

                    <v-layout>
                        <indirizzo-select class="ml-1 mt-1" :paese.sync="azienda_mostrata.nazione"
                            :regione.sync="azienda_mostrata.regione" :provincia.sync="azienda_mostrata.provincia"
                            :comune.sync="azienda_mostrata.comune" :cap.sync="azienda_mostrata.cap"
                            :frazione.sync="azienda_mostrata.frazione" :via.sync="azienda_mostrata.via"
                            :numero-civico.sync="azienda_mostrata.numero_civico" show-frazione :globalDisabled="true"
                            required attach disabled />
                    </v-layout>
                </div>

                <div xs12 class="mt-4">
                    <icon-label icon="contacts" color="accent">{{ $t('label.contatti') }}</icon-label>

                    <v-layout>
                        <v-flex xs12 sm4>
                            <text-field :label="$t('label.pec')" v-model="azienda_mostrata.pec" show-details
                                :v-rules="[$utils.rules.email]" disabled />
                        </v-flex>

                        <v-flex xs12 md4>
                            <text-field :label="$t('label.email')" v-model="azienda_mostrata.email" show-details
                                :v-rules="[$utils.rules.email]" disabled />
                        </v-flex>

                        <v-flex xs12 sm6 md4>
                            <phone-field :label="$t('label.telefono')" v-model="azienda_mostrata.telefono" show-details
                                disabled />
                        </v-flex>

                        <v-flex xs12 sm6 md4>
                            <mobile-phone-field :label="$t('label.cellulare')" v-model="azienda_mostrata.cellulare"
                                show-details disabled />
                        </v-flex>
                    </v-layout>
                </div>

                <template v-if="azienda_mostrata.note && azienda_mostrata.note.length > 0">
                    <v-flex xs12 class="mt-1">
                        <icon-label icon="sort" color="accent">{{ $t('agricoltori.label.dati_aggiuntivi')
                        }}</icon-label>
                    </v-flex>

                    <v-flex xs12 class="mt-1">
                        <div v-for="(item, index) in form.note" :key="item[0]">
                            <span>{{ $t('label.' + item[0]) }}: </span>
                            <b>{{ item[1] }}</b>
                            <v-tooltip bottom>
                                <v-btn slot="activator" small icon class="my-0" @click="form.note.splice(index, 1)">
                                    <v-icon>clear</v-icon>
                                </v-btn>
                                <span>{{ $t('azioni.rimuovi') }}</span>
                            </v-tooltip>
                        </div>
                    </v-flex>
                </template>

            </template>

            <data-table v-if="showedAgricoltore == true" :headers="[
                { text: $t('label.numero_attestato'), value: 'numero', width: 14 },
                { text: $t('label.data'), value: 'data_controllo', width: 14 },
                { text: $t('prenotazioni.label.marca'), value: 'marca', width: 16 },
                { text: $t('prenotazioni.label.modello'), value: 'modello', width: 14 },
                { text: $t('prenotazioni.label.telaio'), value: 'telaio', width: 14 }, // dato mancante 
                { text: $t('prenotazioni.label.scadenza'), value: 'scadenza', width: 14 },
                { text: $t('label.tecnico'), value: 'id_tecnico', width: 14 }]" :items="reports" :loading="loading"
                @click:item="showReportDialog">

                <template slot="items" slot-scope="{ item }">
                    <td>
                        <v-tooltip bottom>
                            <v-icon slot="activator" :color="item.compilato ? 'success' : 'error'">{{ item.compilato ?
                                'check_circle' : 'error' }}</v-icon>
                            <span>{{ item.compilato ? $t('reports.messaggi.compilato') :
                                $t('reports.messaggi.non_compilato') }}</span>
                        </v-tooltip>
                        <span class="ml-2" style="vertical-align: text-bottom">{{ item.numero }}</span>
                    </td>
                    <td>{{ $d($utils.date.toJs(item.data_controllo)) }}</td>
                    <td>{{ item.marca }}</td>
                    <td>{{ item.modello }}</td>
                    <td>{{ item.telaio }}</td>
                    <td>{{ item.scadenza }}</td>
                    <td colspan="2">{{ item.id_tecnico && getNomeCognomeById(item.id_tecnico) }}</td>
                </template>

            </data-table>

            <data-table v-if="showedAgricoltore == false" :items="agricoltori" :headers="[
                { text: $t('label.ragione_sociale'), value: 'ragione_sociale', sortable: true, width: 32 },
                { text: $t('label.cuaa'), value: 'cuaa', sortable: true, width: 15 },
                { text: $t('label.comune'), value: 'comune', width: 11 },
                { text: $t('label.via'), value: 'via', sortable: true, width: 11 },
                { text: $t('label.cap'), value: 'cap', width: 11 },
                { text: $t('label.email'), value: 'email', width: 20 }]" :width-auto="true"
                initial-sort="ragione_sociale" :loading="loading" :search="search"
                @click:item="(agricoltore) => (showEditDialog(agricoltore))">

                <template slot="items" slot-scope="{ item }">
                    <td>{{ item.ragione_sociale }}</td>
                    <td>{{ item.cuaa }}</td>
                    <td>{{ item.nome_comune }}</td>
                    <td>{{ item.via }}</td>
                    <td>{{ item.cap }}</td>
                    <td>{{ item.email || '-' }}</td>
                    <td>
                        <v-btn v-if="!$store.getters.isAbbonamentoExpired" v-show="!showDeleted" icon small flat
                            class="right" @click.stop="showDeleteConfirmDialog(item.id)">
                            <v-icon>clear</v-icon>
                        </v-btn>
                    </td>
                </template>
            </data-table>

            <v-btn v-if="!$store.getters.isAbbonamentoExpired" v-show="!showDeleted" @click="showCreateDialog"
                color="accent" fixed right bottom round large class="mr-2">
                <v-icon class="mr-2">add</v-icon>
                {{ $t('azioni.aggiungi') }}
            </v-btn>

            <report-dialog ref="reportDialog" />
            <agricoltore-dialog ref="agricoltoreDialog" :clienti="clienti" @success="fetchData" />
            <agricoltore-deleted-dialog ref="agricoltoreDeletedDialog" @success="fetchData" />

        </v-flex>
    </v-layout>
</template>

<script>
import DataTable from '@/components/base/DataTable'
import AgricoltoreDialog from '@/components/AgricoltoreDialog'
import AgricoltoreDeletedDialog from '@/components/AgricoltoreDeletedDialog'
import ReportDialog from '@/components/ReportDialog'
import { DatePicker, IndirizzoSelect, MobilePhoneField, PhoneField } from '../../src/components/inputs'

export default {
    name: 'Agricoltori',
    components: { AgricoltoreDeletedDialog, AgricoltoreDialog, DataTable, ReportDialog, DatePicker, IndirizzoSelect, MobilePhoneField, PhoneField },
    data: () => ({
        showDeleted: false,
        loading: false,
        agricoltori: [],
        reports: [],
        search: '',
        showedAgricoltore: false,
        azienda_mostrata: null,
        clienti: []
    }),
    watch: {
        showDeleted: {
            handler: 'fetchData',
            immediate: true
        }
    },
    mounted() {
        //  Per evitare errori prima carico i dati dei tecnici
        this.loading = true
        Promise.all([
            this.$store.dispatch('loadTecnici')
        ]).then(() => {
            this.fetchData(1)
            this.fetchDataGlobal()
        }).catch(e => {
            this.$snackbar.showServerError(e)
            this.loading = false
        })
    },
    methods: {
        showCreateDialog() {
            this.$refs.agricoltoreDialog.showCreate()
        },
        async showEditDialog(agricoltore) {
            this.azienda_mostrata = JSON.parse(JSON.stringify(agricoltore));
            await this.$api.reports.get({ agricoltore: agricoltore.id }, null, null)
                .then((res) => {
                    this.reports = res.data.items;
                }).catch(e => {
                    if (e.response && e.response.status === 404 && e.response.data.message === 'in use') {
                        this.$snackbar.show(this.$t('unita_mobili.errori.riferimenti_attivi'), 'error')
                    } else {
                        this.$snackbar.showServerError(e)
                    }
                })

            this.showedAgricoltore = true;
            // this.$refs.agricoltoreDialog.showEdit(agricoltore)
        },
        showDeletedDialog(agricoltore) {
            this.$refs.agricoltoreDeletedDialog.show(agricoltore)
        },
        showDeleteConfirmDialog(id) {
            this.$confirmDialog.show(id, this.$t('messaggi.conferma_eliminazione'), this.deleteAgricoltore)
        },
        deleteAgricoltore(id) {
            this.$api.agricoltori.delete(id)
                .then(response => {
                    this.$snackbar.show(this.$t('agricoltori.messaggi.eliminato'), 'success')
                    this.fetchData()
                }).catch(e => {
                    if (e.response && e.response.status === 404 && e.response.data.message === 'in use') {
                        this.$snackbar.show(this.$t('unita_mobili.errori.riferimenti_attivi'), 'error')
                    } else {
                        this.$snackbar.showServerError(e)
                    }
                })
        },
        getNomeCognomeById(id) {
            let tecnico = this.$store.getters.getTecnicoById(id);
            return tecnico ? tecnico.nome_cognome : '-';
        },
        showReportDialog(report) {
            this.$refs.reportDialog.show(report, null, true)
        },
        action() {
            if (this.showDeleted) {
                return this.$api.agricoltori.getDeleted()
            } else {
                return this.$api.agricoltori.getAll()
            }
        },
        fetchData() {
            this.loading = true
            this.action()
                .then(response => {
                    this.loading = false
                    this.agricoltori = response.data
                    // Viene forzato l'aggiornamento per i select agricoltore/cliente
                    this.$store.commit('SET_AGRICOLTORI', [])
                })
                .catch(e => {
                    this.$snackbar.showServerError(e)
                    this.loading = false
                })
        },
        fetchDataGlobal() {
            this.loading = true
            this.$api.clienti.getAll()
                .then(response => {
                    this.loading = false
                    this.clienti = response.data
                })
                .catch(e => {
                    this.$snackbar.showServerError(e)
                    this.loading = false
                })
        }
    }
}
</script>
